import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function fmtErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function money(n) {
  return "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export function kg(n) {
  return Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 }) + " Kg";
}

export function num(n, d = 2) {
  return Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: d });
}

// Convert ISO YYYY-MM-DD → display DD-MM-YYYY (falsy passthrough)
export function fmtDate(iso) {
  if (!iso || typeof iso !== "string") return "";
  const m = iso.slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return iso;
  return `${m[3]}-${m[2]}-${m[1]}`;
}

// Convert DD-MM-YYYY (or DD/MM/YYYY) → ISO YYYY-MM-DD; empty passthrough
export function parseDMY(s) {
  if (!s) return "";
  const m = String(s).trim().match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/);
  if (!m) return "";
  const d = m[1].padStart(2, "0"), mo = m[2].padStart(2, "0"), y = m[3];
  return `${y}-${mo}-${d}`;
}
